module.exports = __webpack_public_path__ + "img/guwu1.fb7a5657.png";